import { AgenceService } from 'src/app/Service/agence.service';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { forkJoin } from 'rxjs';
import { Global } from 'src/app/Service/global.service';
declare var $: any;
@Component({
  selector: 'app-agence-section',
  templateUrl: './agence-section.component.html',
  styleUrls: ['./agence-section.component.scss']
})
export class AgenceSectionComponent implements OnInit {

  constructor(private global:Global,private service:AgenceService, private router: Router, private route:ActivatedRoute) { }
  currentlg = '';
  menu =[];
  ngOnInit(): void {
    this.global.CurentLanguage.subscribe(lg => {
      this.currentlg = lg.code;
      const allMenu = [];
      this.menu = [];
      this.service.getMenuData().subscribe(datas => {
        const requests = [];
        datas['value'].forEach(element => {
          const obj =  {
            title : '', 
            url:'', 
            ordre: 0,
            dynamique:false
          }
          if(this.currentlg === 'fr') {
            obj.title = element.Title
          } else if(this.currentlg === 'ar') {
            obj.title =element.TitreAR
         } else  {
          obj.title = element.TitreEN
         }
         obj.url = element.MenuUrl;
         obj.ordre = element.Ordre;
         obj.dynamique = element.PageDynamique;
         if(element.PageDynamique) {
          this.menu.push(obj);
        }
         allMenu.push(obj);
         requests.push(this.service.getMenuPageData(element.MenuUrl, this.currentlg));
        });
         forkJoin(requests).subscribe(dataItems => {
          let i = 0;
          dataItems.forEach(list => {
            if(list['value'].length > 0) {
              this.menu.push(allMenu[i]);
            }
            i++;
          });
          this.menu.sort(function(a, b) {
            return a.ordre - b.ordre;
          }); 
       if(this.menu.length > 0) {
        this.router.navigate(['/agence', this.menu[0].url]);
       } else {
         alert('Pas de page agence'); 
         this.router.navigate(['/']);
       }
      })
    });
  });
  }

}
